<script setup>
const props = defineProps({
  variant: {
    type: String,
    validator: value => ['default', 'delete', 'group-title'].includes(value),
    default: 'default',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
  iconRight: {
    type: String,
    required: false,
  },
  iconPack: {
    type: String,
    default: 'linear',
  },
  selected: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click'])

const handleClick = () => {
  if (props.disabled) return
  emit('click')
}
</script>

<template>
  <p v-if="variant === 'group-title'" class="context-menu-group-title">{{ text }}</p>

  <button
    v-else
    type="button"
    role="menuitem"
    :disabled="disabled"
    @click="handleClick"
    class="context-menu-item"
    :class="[variant]"
  >
    <span class="flex min-w-0 items-center gap-2">
      <ImoIcon v-if="selected" name="check" :size="16" class="text-secondary-50 shrink-0" />
      <ImoIcon v-if="icon" :name="icon" :pack="iconPack" :size="18" />
      <span class="truncate">{{ text }}</span>
    </span>
    <ImoIcon v-if="iconRight" :name="iconRight" :pack="iconPack" :size="18" class="shrink-0" />
  </button>
</template>

<style scoped>
@reference "@/assets/style/main.css";

.context-menu-group-title {
  @apply text-neutral-50 w-full px-2 py-1 text-xs font-semibold whitespace-nowrap;
}

.context-menu-item {
  @apply flex w-full items-center justify-between gap-4 rounded-lg px-4 py-2 text-sm whitespace-nowrap;
}

.default {
  @apply text-neutral-60 outline-none;
  @apply hover:bg-neutral-10 hover:text-neutral-90 focus-visible:bg-neutral-10 focus-visible:text-neutral-90;
  @apply disabled:text-neutral-40 disabled:pointer-events-none;
}

.delete {
  @apply text-error-60 outline-none;
  @apply hover:bg-error-10 focus-visible:bg-error-10;
  @apply disabled:text-error-30 disabled:pointer-events-none;
}
</style>
